import { redirect } from '@solidjs/router';

import type { ServerError, HttpError } from './request';

import { Events, emitEvtBus } from '~/hook/useEvtBus';

function extractErrMessage(input: string): string | null {
  if (!input || typeof input !== 'string') {
    return null;
  }

  try {
    // 方法1: 尝试查找JSON部分 - 从第一个 { 到匹配的 }
    const jsonRegex = /{.*?}/s; // s 标志允许匹配多行
    const match = input.match(jsonRegex);

    if (match && match[0]) {
      const jsonStr = match[0];
      const data = JSON.parse(jsonStr);
      if (data.errMessage) {
        console.log('正则提取JSON成功:', data.errMessage);
        return data.errMessage;
      } else {
        return null;
      }
    }
    return null;
  } catch (e) {
    console.error('所有JSON解析方法都失败:', e);
    return null;
  }
}

export default {
  /** 访问被拒绝（例如 CloudFront 403 错误） */
  403: ({ message }) => {
    console.error('403 访问被拒绝:', message);

    const extractedMessage = extractErrMessage(message);
    // toast()

    // 判断错误内容来确定不同的处理方式
    if (message.includes('cloudfront') || message.includes('Request blocked')) {
      // CloudFront 特定的错误
      return {
        success: false,
        error: true,
        message: t('The server request was rejected'),
        errCode: 'CLOUDFRONT_BLOCKED',
      };
    }

    // 其他类型的 403 错误
    return {
      success: false,
      error: true,
      message: extractedMessage ?? t('You do not have permission to access this resource'),
      errCode: 'ACCESS_DENIED',
    };
  },
  // 500 服务器错误
  500: ({ message }) => {
    console.error('500 服务器错误:', message);
    const extractedMessage = extractErrMessage(message);
    return {
      success: false,
      error: true,
      message: extractedMessage ?? t('Internal Server Error'),
      errCode: 'INTERNAL_SERVER_ERROR',
    };
  },
  //非法地区
  12020001: () => {
    throw redirect('/ban');
  },
  // 账户不可用
  12000005: () => {
    // 触发显示弹窗
    emitEvtBus(Events.ACCOUNT_UNAVAILABLE);

    return {
      success: false,
      error: true,
      message: t('Account Unavailable'),
      errCode: 'ACCOUNT_UNAVAILABLE',
    };
  },
} as Record<number, (err: ServerError | HttpError) => any>;
